import { API, graphqlOperation } from "aws-amplify";
import { ICustomerStatRepository } from "./customerStat.types";
import * as queries from "@/customGraphql/queires";
import { Stat } from "@/entities";
import dayjs from "dayjs";

export class CustomerStatAPIRepository implements ICustomerStatRepository {
    // async getCustomerStat(id: string, granularity: string, timestamp: number): Promise<Stat> {
    //     const result = await API.graphql(
    //         graphqlOperation(queries.getSaleCustomerStat, {
    //             id,
    //             granularity,
    //             timestamp,
    //             // nextToken,
    //             // limit: 1,
    //         })
    //     ) as any;

    //     console.log(result.data.getSaleCustomerStat);
    //     return new Stat(result.data.getSaleCustomerStat);
    // }

    async listCustomerStatByGranularityWithTimestamp(
        granularity: string,
        timestamp?: { eq?: number },
        nextToken?: string
    ): Promise<any> {
        const variables = {
            granularity,
            timestamp,
            nextToken,
        };
        console.log("CustomerStatAPI.listCustomerStatByGranularityWithTimestamp variables:", variables);

        const result = (await API.graphql({
            ...graphqlOperation(
                queries.customerStatByGranularityWithTimestamp,
                variables
            ),
            ...{
                authMode: "AMAZON_COGNITO_USER_POOLS",
            },
        })) as any;

        console.log("CustomerStatAPI.listCustomerStatByGranularityWithTimestamp result:", result);

        return {
            items: result.data.customerStatByGranularityWithTimestamp.items.map(
                (item: any) => new Stat(item)
            ),
            nextToken:
                result.data.customerStatByGranularityWithTimestamp.nextToken,
        };
    }

    // async refreshDailyStat(): Promise<void> {
    //     const result = await API.post("saletoolapi","/stat/branch/daily", {
    //         body: {
    //             date: dayjs().format("YYYY-MM-DD")
    //         }
    //     })
    //     console.log({result})
    //     return;
    // }
}
